import calculateEffectiveFate from './calculateEffectiveFate';
import makeFateRefreshCard from './makeFateRefreshCard';

export default function purchaseItemSuccess(state, payload) {
  const updatedFateCards = [
    makeFateRefreshCard(payload),
    ...payload.fateCards,
  ];

  return {
    ...state,
    isPurchasing: false,
    data: {
      ...payload,
      currentFate: calculateEffectiveFate(payload),
      fateCards: updatedFateCards,
    },
    purchaseComplete: true,
    message: null,
  };
}